import actionTypes from '../../constants/action-types';

const cleanUpCustomColorsFromActivePage = () => ({
  type: actionTypes.CLEAN_UP_CUSTOM_COLORS_FROM_ACTIVE_PAGE,
});

export default cleanUpCustomColorsFromActivePage;
